import { Link } from "react-router-dom";
import Seo from "@/lib/seo";
import Navbar from "@/components/Navbar";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <>
      <Seo title="Payment Cancelled" path="/payment/cancel" noindex description="Payment cancelled." />
      <Navbar />
      <div className="min-h-[calc(100vh-73px)] flex items-center justify-center p-8">
        <div className="max-w-lg text-center border border-zinc-800 p-12" data-testid="payment-cancel-card">
          <XCircle size={56} weight="duotone" className="text-zinc-500 mx-auto mb-6" />
          <div className="text-[10px] tracking-[0.3em] uppercase text-red-500 mb-3">— Canceled</div>
          <h1 className="font-display text-4xl uppercase tracking-tighter mb-4">No harm done.</h1>
          <p className="text-zinc-400 text-sm mb-8">Your card wasn't charged. Come back when you're ready.</p>
          <div className="flex gap-3 justify-center">
            <Link to="/pricing" className="bg-red-600 text-white px-6 py-3 text-xs tracking-[0.2em] uppercase btn-brutal btn-brutal-red" data-testid="cancel-back-pricing">
              Back to Pricing
            </Link>
            <Link to="/dashboard" className="border border-zinc-700 px-6 py-3 text-xs tracking-[0.2em] uppercase btn-brutal hover:border-white">
              Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
